import React from 'react';

import HttpService from '../views/services/components/httpservices';

import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CListGroup,
  CListGroupItem,
  CImg
} from '@coreui/react'
import { connect } from 'react-redux';
// import { decryptor } from '../helpers/hasher.helper';

const header = {
  'Content-Type': 'application/json',
  'authorization': localStorage.getItem("token")
};

class TheHeaderDropdown extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      isUserLoged: true,
      isUserData: '',
      isAdmin: false
    }

  }
  isExistUser = async () => {
    if (localStorage.getItem("userId")) {
      var response = await HttpService.get("get_user/", header).catch((error) => {
        return error;
      });
      console.log(response)
      const decryptedData = response.data.data//decryptor(response.data.data)
      if (localStorage.getItem('role') === 'financer') {
        localStorage.setItem('UserControl', decryptedData.permissions.UserControl); //financer UserControl
      }
      if (localStorage.getItem('role') === 'retailer') {
        localStorage.setItem('UserControl', decryptedData.permissions.UserControl); //financer UserControl
      }
      if (response && (response.status === 201 || response.status === 200)) {
        this.setState({
          isUserData: decryptedData,
        });
        const data = decryptedData;
        this.props.updateLoggedInUser({
          _id: data._id,
          name: data.name,
          username: data.username,
          is_super: data.is_super,
          role: data.role
        });
        return true;
      } else if (response && (response.response && response.response.data)) {
        var role = localStorage.getItem("role");
        if (role === "admin") {
          this.setState({
            isUserLoged: false,
            isAdmin: true
          });
        } else {
          this.setState({
            isUserLoged: false
          });
        }
      } else {
        this.setState({
          isUserLoged: false
        });
      }
    } else {
      this.setState({
        isUserLoged: false
      });
    }
  }
  componentDidMount() {
    this.isExistUser();
  }
  render() {
    const { isUserLoged, isUserData } = this.state;
    return (
      <>
        {localStorage.getItem('role') === "admin" ? <CDropdown
          inNav
          className="c-header-nav-items mx-2"
          direction="down"
        >
          <CDropdownToggle className="c-header-nav-link" caret={false}>
            <div className="c-avatar">
              <CImg
                src={window.location.origin + '/4.jpg'}
                className="c-avatar-img"
                alt="Profile"
              />
            </div>
          </CDropdownToggle>
          <CDropdownMenu className="pt-0 acc-details" style={{"padding":0}} placement="bottom-end">
            <CDropdownItem
              header
              tag="div"
              color="light"
            >
              <strong>Account</strong>
            </CDropdownItem>
            {isUserLoged &&
              <>
                <CListGroup>
                  <CListGroupItem>
                    Name
                    <CBadge color="danger" className="float-right mfs-auto">{isUserData.name}</CBadge>
                  </CListGroupItem>
                  <CListGroupItem>
                    Username
                    <CBadge color="danger" className="float-right mfs-auto">{isUserData.username}</CBadge>
                  </CListGroupItem>
                  {localStorage.getItem("role") !== "admin" ?
                    <>
                      <CListGroupItem>
                        User Id
                        <CBadge color="info" className="float-right mfs-auto">{isUserData.user_id}</CBadge>
                      </CListGroupItem>
                      <CListGroupItem>
                        GST
                        <CBadge color="success" className="float-right mfs-auto">{isUserData.gst}</CBadge>
                      </CListGroupItem>
                      <CListGroupItem>
                        Phone Number
                        <CBadge color="warning" className="float-right mfs-auto">{isUserData.phone}</CBadge>
                      </CListGroupItem>
                    </>
                    : ''}
                  {/* <CListGroupItem className="d-flex">
                    <CLink
                        className="c-subheader-nav-link mb-1 btn btn-warning btn-sm"
                        aria-current="page"
                        to={"/user-management/user/packagehistory/"}
                      >Package History</CLink>
                    {localStorage.getItem("role") !== "admin" ? 
                    <CLink
                        className="c-subheader-nav-link mb-1 btn btn-info btn-sm"
                        aria-current="page"
                        to={"/user-management/user/edit/"}
                      >Edit Details</CLink>
                      : ' ' }
                    <CLink
                        className="c-subheader-nav-link mb-1 btn btn-warning btn-sm"
                        aria-current="page"
                        to={"/user-management/user/change-password/"}
                      >Change Password</CLink>
                </CListGroupItem> */}
                </CListGroup>
              </>
            }
          </CDropdownMenu>
        </CDropdown> : ""}
      </>
    );
  }

}


function mapDispatchToProps(dispatch) {
  return({
      updateLoggedInUser: (data) => {dispatch({ type: 'assign/loggedInUser', loggedInUser: data })}
  });
}

export default connect(null, mapDispatchToProps)(TheHeaderDropdown);
